<div *ngIf="cargadoDatos==true">
  <h1 translate>dashboard.perfil.misalaS.pi.titulo</h1>
  <div class="containerForm">
    <form (ngSubmit)="actualizar()" #forma="ngForm">
      <!--PIN ADMIN FORM-->

      <div class="formgroup">
        <label for="pinAdm"><b translate>dashboard.perfil.misalaS.pi.pin</b></label>
        <input
          type="number"
          #pinAdm="ngModel"
          [(ngModel)]="datosPin"
          placeholder="..."
          name="pinAdm"
          class="form-control"
          maxlength="4"
          max="9999"
          required
          [ngClass]="{
            'is-valid': !pinAdm.invalid,
            'is-invalid': pinAdm.invalid
          }"
        />
      </div>
      <div
        class="invalid-feedback"
        *ngIf="pinAdm.invalid && (pinAdm.dirty || pinAdm.touched)"
      >
        <div class="invalid-feedback" *ngIf="pinAdm.errors.required" translate>
          dashboard.perfil.misalaS.pi.requerido
        </div>
        <div
          class="invalid-feedback"
          *ngIf="pinAdm.errors.max"
          translate
        >
          dashboard.perfil.misalaS.pi.max
        </div>
      </div>

      <!-- <div class="formgroup">
        <label for="pinInv"><b>Permitir invitados</b></label>
        
        <select name="permitir" [(ngModel)]="datosPermitir"   class="form-control">
          <option value="true">Si</option>
          <option value="false">No</option>
        </select>
      </div> -->

      <!--PIN GUESTS FORM-->
      <!-- <div *ngIf="datosPermitir == 'true'"> -->
        <div class="formgroup">
          <label id="pinInv" for="pinInv"><b>{{'dashboard.perfil.misalaS.pi.invitados' | translate}}</b> <p transalate >{{'dashboard.perfil.misalaS.pi.condicion' | translate}}<br>{{'dashboard.perfil.misalaS.pi.vacio' | translate}}</p></label>
          <input
            type="number"
            #pinInv="ngModel"
            [(ngModel)]="datosPinInvitado"
            placeholder="{{'dashboard.perfil.misalaS.pi.no' | translate}}"
            name="pinInv"
            class="form-control"
            max="9999"
            min="0"
            [ngClass]="{
              'is-valid': !pinInv.invalid,
              'is-invalid': pinInv.invalid
            }"
          />
        </div>

        <div
          class="invalid-feedback"
          *ngIf="pinInv.invalid && (pinInv.dirty || pinInv.touched)"
        >
          <div translate *ngIf="pinInv.errors.max || pinInv.errors.min">
            dashboard.perfil.misalaS.pi.max
          </div>
        </div>
      <!-- </div> -->

      <!--BOTON SUBMIT-->
      <button
        (click)="checktrue()"
        translate
        type="submit"
        [disabled]="!forma.valid"
        class="button medium center"
        translate
      >
      {{'dashboard.perfil.misalaS.pi.enviar' | translate}}
      </button>
      <!-- <div id="check" >{{response}}</div> -->
    </form>
  </div>
</div>

<!-- popup.component.html -->
<div class="overlay" *ngIf="isOpen">
  <div class="popup">
    <h2>{{response}}</h2>
  </div>
</div>
